import { IBrand } from 'entities/Brand';
import { IOffer } from 'entities/Offer';
import { IBaseResponse } from 'shared/typings';

export enum EReportTypes {
	ACTION = 'actions',
	DATE = 'date',
	OFFER = 'offers',
	SOURCE = 'sources',
}

export enum EReportGroupBy {
	DAY = 'days',
	MONTH = 'months',
	YEAR = 'years',
}

export enum EActionReportStatuses {
	REJECTED = 'rejected',
	PENDING = 'pending',
	AWAITING_CONFIRMATION = 'awaiting_confirmation',
	AWAITING_PAYMENT = 'awaiting_payment',
	READY_FOR_WITHDRAWAL = 'ready_for_withdrawal',
	PAID = 'paid',
}

export enum EReportConversionTypes {
	CROSS = 'true',
	DIRECT = 'false',
}

export interface IDateReport {
	date: string;
	clicks_count: number;
	actions_count: number;
	cross_sell_count: number;
	direct_sell_count: number;
	pending_amount: string;
	rejected_amount: string;
	approved_amount: string;
	cr: string;
	ar: string;
	epc: string;
	epl: string;
	is_total?: boolean;
}

export interface IOfferReport {
	offer: IOffer | null;
	brand: IBrand | null;
	clicks_count: number;
	actions_count: number;
	cross_sell_count: number;
	direct_sell_count: number;
	pending_amount: string;
	rejected_amount: string;
	approved_amount: string;
	cr: string;
	ar: string;
	epc: string;
	epl: string;
	is_total?: boolean;
}

export interface ISourceReport {
	source: {
		uuid: string;
		name: string;
	} | null;
	clicks_count: number;
	actions_count: number;
	cross_sell_count: number;
	direct_sell_count: number;
	pending_amount: string;
	rejected_amount: string;
	approved_amount: string;
	cr: string;
	ar: string;
	epc: string;
	epl: string;
	is_total?: boolean;
}

export interface IActionReport {
	order_id: string;
	date: string;
	offer: IOffer | null;
	click_offer: IOffer | null;
	cross_sell: boolean;
	brand: IBrand | null;
	source: {
		uuid: string;
		name: string;
	} | null;
	geo: string | null;
	comment: string;
	status: EActionReportStatuses;
	amount: string;
	currency: string;
	title: string;
	ip_addr: string;
	is_total?: boolean;
	subid1?: string;
	subid2?: string;
	subid3?: string;
}

export type TReportList = IBaseResponse<IDateReport[] | IActionReport[] | IOfferReport[] | ISourceReport[] | null> & {
	total_current_page: IDateReport | IActionReport | IOfferReport | ISourceReport;
	total_all_pages: IDateReport | IActionReport | IOfferReport | ISourceReport;
};

export interface IMetric {
	date: string;
	currency: string;
	approved_amount: number;
	actions_count: number;
	count: number;
	joined_count: number;
	cr: number;
	ar: number;
	epc: number;
	epl: number;
	amount: number;
	clicks_count: number;
	approved_actions_count: number;
}
